import React from "react";

const Dropdown = ({ label, value, onChange, options }) => {
  return (
    <div className="mb-2">
      {label && <label className="form-label">{label}</label>}
      <select
        className="form-select"
        value={value?.value ?? value ?? ""}
        onChange={(e) => {
          const selected = options.find(
            (opt) => opt.value.toString() === e.target.value
          );
          onChange(selected ?? e.target.value);
        }}
      >
        <option value="">Select...</option>
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
